// hooks/useRequestSubmission.js
import { useState } from "react"
import { useTranslation } from "react-i18next"

import { getRequestPdfEndpoint } from "../helpers/general"
import { sendPdfRequest } from "../helpers/pdfService"

export default function useRequestSubmission({ model, generateMergedImage }) {
  const { i18n } = useTranslation()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [success, setSuccess] = useState(false)

  const resetSubmissionStatus = () => {
    setError(false)
    setSuccess(false)
  }

  const submitRequest = async ({
    configuration,
    userValues = null,
    isFinalSubmit = false,
    recaptchaToken,
  }) => {
    setLoading(true)
    setError(false)
    setSuccess(false)

    try {
      const mergedImageBase64 = await generateMergedImage(configuration)
      const lang = i18n.language
      const endpoint = getRequestPdfEndpoint()
      const currentPage = window.location.href

      const payload = {
        lang,
        configurator: model,
        configuration,
        image: mergedImageBase64,
        isFinalSubmit,
        userValues,
        recaptchaToken,
        currentPage,
      }
      await sendPdfRequest(endpoint, payload)

      setSuccess(true)
      return { success: true }
    } catch (err) {
      console.error("Error al enviar solicitud:", err)
      setError(true)
      return { success: false, error: err }
    } finally {
      setLoading(false)
    }
  }

  return { submitRequest, resetSubmissionStatus, loading, error, success }
}
